import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Payment } from 'src/app/core/dtos/payment';
import { CreatePaymentRequest } from 'src/app/core/dtos/createPaymentRequest';
import { environment } from 'src/environments/environment.development';


@Injectable({
  providedIn: 'root'
})
export class PaymentService {
    
    private apiUrl = `${environment.apiUrl}/Pagos/`;

  constructor(private http: HttpClient) {}

  /**
   * Listar pagos por cliente
   */
  getPaymentsByCliente(usuarioId:number,clienteId: number): Observable<Payment[]> {
    return this.http.get<Payment[]>(`${this.apiUrl}getByCliente?usuarioId=${usuarioId}&clienteId=${clienteId}`);
  }

  /**
   * Registrar un nuevo pago
   */
  createPayment(usuarioId:number,request: CreatePaymentRequest): Observable<Payment> {
    return this.http.post<Payment>(`${this.apiUrl}crearPago?usuarioId=${usuarioId}`, request);
  }
}
